"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentPanelService = void 0;
var _contentPanel = require("../controllers/contentPanel.controller");
var ContentPanelService = {
  contentPanel: {
    root: _contentPanel.config.contentPanel + "/deleteCpFolder",
    accessPermission: _contentPanel.config.contentPanel + "/access-permission",
    checkName: _contentPanel.config.contentPanel + "/name/check",
    panelSlides: _contentPanel.config.contentPanel + "/panel-slides",
    copyContent: _contentPanel.config.contentPanel + "/copy-content",
    notification: _contentPanel.config.contentPanel + "/notification",
    create: _contentPanel.config.contentPanel,
    saveDraft: _contentPanel.config.contentPanel + "/draft",
    createRootNode: _contentPanel.config.contentPanel + "/root",
    editorLock: _contentPanel.config.contentPanel + "/editor/lock",
    editorUnlock: _contentPanel.config.contentPanel + "/editor/unlock",
    editor: _contentPanel.config.contentPanel + "/editor",
    typeList: _contentPanel.config.contentPanel + "/type/list",
    impactDataField: _contentPanel.config.contentPanel + "/data-map"
  },
  rgcpHtml: {
    list: _contentPanel.config.rgcpHtml + "/list",
    defaultHtmlList: _contentPanel.config.rgcpHtml + "/list/default",
    fetch: _contentPanel.config.rgcpHtml,
    add: _contentPanel.config.rgcpHtml,
    update: _contentPanel.config.rgcpHtml,
    delete: _contentPanel.config.rgcpHtml,
    types: _contentPanel.config.rgcpHtml + "/types/list",
    previewList: _contentPanel.config.rgcpHtml + "/list/preview",
    panelPreviewList: _contentPanel.config.rgcpHtml + "/template",
    performancePreview: _contentPanel.config.rgcpHtml + "/graph",
    softDelete: _contentPanel.config.rgcpHtml + "/delete/soft",
    softDeleteRestore: _contentPanel.config.rgcpHtml + "/delete/soft/restore",
    softDeletedList: _contentPanel.config.rgcpHtml + "/list/soft/deleted",
    bulkSoftDelete: _contentPanel.config.rgcpHtml + "/bulk/delete/soft",
    bulkHardDelete: _contentPanel.config.rgcpHtml + "/bulk/delete/hard",
    bulkRestore: _contentPanel.config.rgcpHtml + "/bulk/delete/soft/restore"
  },
  rgcpHtmlMap: {
    list: _contentPanel.config.rgcpHtmlMap + "/list",
    fetch: _contentPanel.config.rgcpHtmlMap,
    add: _contentPanel.config.rgcpHtmlMap,
    update: _contentPanel.config.rgcpHtmlMap,
    delete: _contentPanel.config.rgcpHtmlMap,
    softDelete: _contentPanel.config.rgcpHtmlMap + "/delete/soft",
    softDeleteRestore: _contentPanel.config.rgcpHtmlMap + "/delete/soft/restore",
    softDeletedList: _contentPanel.config.rgcpHtmlMap + "/list/soft/deleted",
    bulkSoftDelete: _contentPanel.config.rgcpHtmlMap + "/bulk/delete/soft",
    bulkHardDelete: _contentPanel.config.rgcpHtmlMap + "/bulk/delete/hard",
    bulkRestore: _contentPanel.config.rgcpHtmlMap + "/bulk/delete/soft/restore"
  },
  cpSite: {
    panelList: _contentPanel.config.cpSite + "/cp-site-list",
    addSiteDefault: _contentPanel.config.cpSite + "/default",
    updateGreeting: _contentPanel.config.cpSite + "/greeting-message",
    updateHeaderImage: _contentPanel.config.cpSite + "/header-image",
    updateFundSequencePanel: _contentPanel.config.cpSite + "/fund-panel-sequence",
    getHeaderImage: _contentPanel.config.cpSite + "/builder-site",
    getBuilderSiteById: _contentPanel.config.cpSite + "/builder-site/id",
    getGreeting: _contentPanel.config.cpSite + "/greeting-message",
    deletePanel: _contentPanel.config.cpSite,
    headerImageList: _contentPanel.config.cpSite + "/header-image-list"
  },
  cpReport: {
    getReportDefault: _contentPanel.config.cpReport + "/default",
    addReportDefault: _contentPanel.config.cpReport + "/default",
    addUpdateReportDefault: _contentPanel.config.cpReport + "/default/cp",
    getReportDefaultByOrgId: _contentPanel.config.cpReport + "/default/cp",
    updateGreeting: _contentPanel.config.cpReport + "/greeting-mesage",
    updateHeaderImage: _contentPanel.config.cpReport + "/header-image",
    updateFundSequencePanel: _contentPanel.config.cpReport + "/fundPanelSequence",
    getHeaderImage: _contentPanel.config.cpReport + "/builder-report",
    getBuilderReportById: _contentPanel.config.cpReport + "/builder-report/id",
    panelList: _contentPanel.config.cpReport + "/cp-report-list",
    getAssetFolderList: _contentPanel.config.cpReport + "/asset-folder-list",
    // api's not available
    getGreeting: _contentPanel.config.cpReport + "/greeting-message",
    deletePanel: _contentPanel.config.cpReport,
    headerImageList: _contentPanel.config.cpReport + "/header-image-list"
  },
  cpFolder: {
    addFolder: _contentPanel.config.cpFolder,
    getFolderList: _contentPanel.config.cpFolder,
    updateFolder: _contentPanel.config.cpFolder,
    getAllFolder: _contentPanel.config.cpFolder + "/list",
    getAllInitialfolder: _contentPanel.config.cpFolder + "/initials/list",
    getAllCpRootNode: _contentPanel.config.cpFolder + "/list/parents",
    deleteCpFolder: _contentPanel.config.cpFolder,
    cpFolderDetails: _contentPanel.config.cpFolder + "/details",
    cpFolderEdit: _contentPanel.config.contentPanel + "/edit",
    cpFolderDetailsHtml: _contentPanel.config.cpFolder + "/details/replaced",
    deleteSoft: _contentPanel.config.cpFolder + "/delete/soft",
    softRestore: _contentPanel.config.cpFolder + "/delete/soft/restore",
    bulkSoftRestore: _contentPanel.config.cpFolder + "/bulk/delete/soft/restore",
    bulkHardDelete: _contentPanel.config.cpFolder + "/bulk/delete/hard",
    listSoftDeleted: _contentPanel.config.cpFolder + "/list/soft/deleted"
  },
  activeBroadcast: {
    create: _contentPanel.config.activeBroadcast,
    findDetail: _contentPanel.config.activeBroadcast,
    findList: _contentPanel.config.activeBroadcast,
    update: _contentPanel.config.activeBroadcast,
    delete: _contentPanel.config.activeBroadcast,
    sendNotification: _contentPanel.config.activeBroadcast + "/notification"
  },
  templateStructure: {
    root: _contentPanel.config.templateStructure
  },
  standardTemplate: {
    fetch: _contentPanel.config.standardTemplate,
    list: _contentPanel.config.standardTemplate + "/list",
    add: _contentPanel.config.standardTemplate,
    update: _contentPanel.config.standardTemplate,
    delete: _contentPanel.config.standardTemplate,
    softDelete: _contentPanel.config.standardTemplate + "/delete/soft",
    softDeleteRestore: _contentPanel.config.standardTemplate + "/delete/soft/restore",
    softDeletedList: _contentPanel.config.standardTemplate + "/list/soft/deleted",
    bulkSoftDelete: _contentPanel.config.standardTemplate + "/bulk/delete/soft",
    bulkHardDelete: _contentPanel.config.standardTemplate + "/bulk/delete/hard",
    bulkRestore: _contentPanel.config.standardTemplate + "/bulk/delete/soft/restore"
  },
  interaction: {
    create: _contentPanel.config.interaction,
    update: _contentPanel.config.interaction,
    fetch: _contentPanel.config.interaction,
    fetchList: _contentPanel.config.interaction + "/list",
    softDelete: _contentPanel.config.interaction + "/delete/soft",
    hardDelete: _contentPanel.config.interaction + "/delete/hard",
    restore: _contentPanel.config.interaction + "/delete/soft/restore",
    softDeleteList: _contentPanel.config.interaction + "/list/soft/deleted",
    softDeleteBulk: _contentPanel.config.interaction + "/bulk/delete/soft",
    deleteBulk: _contentPanel.config.interaction + "/bulk/delete/hard",
    restoreBulk: _contentPanel.config.interaction + "/bulk/delete/soft/restore",
    finalSave: _contentPanel.config.interactionFinal + "/response",
    finalUpdate: _contentPanel.config.interactionFinal + "/response",
    downloadResponseCp: _contentPanel.config.interactionFinal + "/response/download",
    responseList: _contentPanel.config.interactionFinal + "/response/list",
    responseSubmit: _contentPanel.config.interactionFinal + "/response/submit",
    subFolderList: _contentPanel.config.interactionFinal + "/type/list",
    ipFolderFetch: _contentPanel.config.interactionFinal + "/type/list",
    ipFolderAdd: _contentPanel.config.interactionFinal + "/type",
    ipFolderUpdate: _contentPanel.config.interactionFinal + "/type",
    ipFolderDelete: _contentPanel.config.interactionFinal + "/type/delete/hard",
    ipFolderDeleteBulk: _contentPanel.config.interactionFinal + "/type/bulk/delete/hard",
    ipFolderDeleteSoft: _contentPanel.config.interactionFinal + "/type/delete/soft",
    ipFolderDeleteSoftBulk: _contentPanel.config.interactionFinal + "/type/bulk/delete/soft",
    softDeleteListFolder: _contentPanel.config.interactionFinal + "/type/list/soft/deleted",
    restoreFolder: _contentPanel.config.interactionFinal + "/type/delete/soft/restore",
    restoreBulkFolder: _contentPanel.config.interactionFinal + "/type/bulk/delete/soft/restore"
  }
};
exports.ContentPanelService = ContentPanelService;